module.exports = __webpack_public_path__ + "static/img/MV22.5c8dba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV22.jpg
// module id = wsyJ
// module chunks = 0